import styled, { keyframes } from 'styled-components';
import { NotificationTypes, NotificationColors } from './constants';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
`;

export const ToastContainer = styled.div`
	display: flex;
	align-items: center;
	position: fixed;
	top: 8%;
	right: 2%;
	padding: 12px 20px;
	border-radius: 4px;
	color: #ffffff;
	z-index: 999999999999;
	background-color: ${({ status }) => {
		switch (status) {
			case NotificationTypes.success:
				return NotificationColors.success;
			case NotificationTypes.warning:
				return NotificationColors.warning;
			case NotificationTypes.danger:
				return NotificationColors.danger;
			case NotificationTypes.simple:
				return NotificationColors.simple;
			default:
				return '#333333';
		}
	}};
	animation: ${({ visible }) => (visible ? slideIn : slideOut)} 0.5s ease-in-out;
`;

export const Message = styled.div`
	flex: 1;
	font-size: 15px;
`;
